import React, { useEffect, useState } from 'react';
import { Table, Tooltip, Button, message } from 'antd';
import { PoweroffOutlined, CheckCircleOutlined } from '@ant-design/icons';
import useParticipantBadges from '../../../hooks/participants/useParticipantBadges';
import axios from '../../../config/axiosInstance';

const BadgesTab = ({ participantId, host }) => {
    const { badges, loading, fetchBadges } = useParticipantBadges(participantId, host);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!loaded) {
            fetchBadges();
            setLoaded(true);
        }
    }, [loaded]);

    const getToken = async () => {
        const res = await axios.get(`/regasus/token?host=${host}`);
        return res.data.access_token;
    };

    const handleToggleBadge = async (badge) => {
        try {
            const token = await getToken();
            if (!token) return message.error('No token received');

            const endpoint = badge.disabled ? '/regasus/enable-badge' : '/regasus/disable-badge';

            await axios.put(endpoint, {
                token,
                host,
                badgeId: badge.id,
            });

            message.success(`Badge ${badge.badgeID} ${badge.disabled ? 'enabled' : 'disabled'} successfully`);
            fetchBadges();
        } catch (err) {
            console.error(err);
            message.error('Failed to update badge');
        }
    };

    const columns = [
        {
            title: 'Badge No',
            dataIndex: 'badgeNo',
            key: 'badgeNo',
        },
        {
            title: 'Disabled At',
            dataIndex: 'disabled',
            key: 'disabled',
            render: (disabled) =>
                disabled ? (
                    new Date(disabled).toLocaleString()
                ) : (
                    <span style={{ color: 'green', fontWeight: 'bold' }}>Active</span>
                ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Tooltip
                    title={record.disabled ? 'Enable badge (deactivates others)' : 'Disable badge'}
                >
                    <Button
                        icon={record.disabled ? <CheckCircleOutlined /> : <PoweroffOutlined />}
                        type={record.disabled ? 'default' : 'primary'}
                        danger={!record.disabled}
                        onClick={() => handleToggleBadge(record)}
                    />
                </Tooltip>
            ),
        },
    ];

    return (
        <Table
            size="small"
            scroll={{ x: 'max-content' }}
            columns={columns}
            dataSource={badges.map((b, i) => ({
                key: b.id || i,
                badgeNo: b.badgeNo,
                disabled: b.disabled,
                badgeID: b.badgeID,
                ...b
            }))}
            loading={loading}
            pagination={false}
        />
    );
};

export default BadgesTab;